import { useTranslation } from 'react-i18next'
import { Link } from 'react-router'

import { URL_PAGE_POLICY } from '@shared/contants'

import styles from './styles.module.scss'

interface PolicyLinkProps {
  buttonText: string;
}

export default function PolicyLink (props: PolicyLinkProps) {
  const { buttonText } = props
  const { t: tc } = useTranslation('common')

  return (
    <span className={styles.root}>
      {tc('policy.form.1', {
        button: buttonText,
      })}
      <Link to={URL_PAGE_POLICY} target="_blank">
        {tc('policy.form.2')}
      </Link>
    </span>
  )
}
